import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@sunwing/wvi-components";
import { getCookie, setCookie } from "../../utils";
import { RCL as useTranslation } from "../RCL";
import * as styles from "./CookieAcceptanceBanner.module.scss";

const CookieAcceptanceBanner = ({ onLoad, onUnload, hideCookieBanner }) => {
	const bannerText = useTranslation({ searchKey: "cookie-accept-banner-wvi" });
	const buttonText = useTranslation({ searchKey: "accept" });

	const [shouldShowBanner, setShouldShowBanner] = useState(false);

	useEffect(() => {
		const cookieAcceptance = getCookie("cookie-acceptance-wvi");
		if (!hideCookieBanner && !cookieAcceptance) {
			setShouldShowBanner(true);
			if (onLoad && typeof onLoad === "function") {
				onLoad();
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleClick = () => {
		const expiration = new Date();
		expiration.setUTCMonth(expiration.getMonth() + 1);

		const cookieDomain = window.location.hostname.replace(/^www\./, ".");
		setCookie("cookie-acceptance-wvi", true, "/", cookieDomain, expiration);
		setShouldShowBanner(false);
		if (onUnload && typeof onUnload === "function") {
			onUnload();
		}
	};

	if (!shouldShowBanner) {
		return null;
	}
	return (
		<div className={styles.banner}>
			<div className={styles.bannerContainer}>
				<span className={styles.text}>{bannerText} </span>
				<Button className={styles.acceptBtn} variant="actionInverse" onClick={handleClick}>
					{buttonText}
				</Button>
			</div>
		</div>
	);
};

CookieAcceptanceBanner.propTypes = {
	onLoad: PropTypes.func,
	onUnload: PropTypes.func,
	hideCookieBanner: PropTypes.bool,
};
CookieAcceptanceBanner.defaultProps = {
	onLoad: undefined,
	onUnload: undefined,
	hideCookieBanner: false,
};
export default CookieAcceptanceBanner;
export { CookieAcceptanceBanner };
